import React from 'react';
import OdooCRM from '../components/OdooCRM';
import Contact from '../components/Contact';

const OdooCRMPage: React.FC = () => {
  return (
    <>
      <OdooCRM />
      <Contact />
    </>
  );
};

export default OdooCRMPage;
